import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { SegmentedControl } from '@radix-ui/themes'
import { IconBiohazard, IconDatabase, IconNetwork, IconRepeat } from '@tabler/icons-react'
import { selectAdversaries, setVisualizationToShow } from '../../reducers/adversaries'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { selectUser } from '../../reducers/users'
import { inPov } from '../../utils/session'

interface IVisualizationsHeaderProps {
  currentPage: string
}

const VisualizationsHeader = (props: IVisualizationsHeaderProps) => {
  const { currentPage } = props
  const dispatch = useDispatch()
  const { session } = useSelector(selectUser)
  const { visualizationToShow } = useSelector(selectAdversaries)
  const [pageTitle, setPageTitle] = useState<string>('Adversaries')

  useEffect(() => {
    switch (currentPage) {
      case 'ADVERSARIES':
        setPageTitle('Adversaries')
        break
      case 'INTEL-REPORTS':
        setPageTitle('Reports')
        break
      case 'VISUALIZATIONS':
        setPageTitle('Visualizations')
        break
      case 'VICTIMOLOGY':
        setPageTitle('Victimology')
        break
      default:
        setPageTitle('Adversaries')
    }
  }, [currentPage])

  return (
    <div className="w-full absolute h-[74px] flex" style={{ top: inPov(session) ? '42px' : '0px' }}>
      <div className="h-[26px] flex items-center mt-6 ml-6 w-[182px]">
        <LogoGradientIcon height="26" width="71" />
      </div>
      <div className="flex items-center flex-grow">
        <div className="font-semibold text-mainText text-xl ml-4">{pageTitle}</div>
        {currentPage === 'VISUALIZATIONS' && (
          <SegmentedControl.Root
            value={visualizationToShow}
            defaultValue="networks"
            className="h-[38px] mx-auto bg-controllerBackground text-controllerText"
            onValueChange={(newValue: string) => dispatch(setVisualizationToShow(newValue))}
          >
            <SegmentedControl.Item value="networks">
              <div className="flex">
                <IconNetwork
                  size={18}
                  className={`mr-2 mt-0.5 ${visualizationToShow === 'networks' ? 'text-menuPurple' : 'text-gray-600'}`}
                />
                Networks
              </div>
            </SegmentedControl.Item>
            <SegmentedControl.Item value="malware">
              <div className="flex">
                <IconBiohazard
                  size={18}
                  className={`mr-2 mt-0.5 ${visualizationToShow === 'malware' ? 'text-menuPurple' : 'text-gray-600'}`}
                />
                Malware
              </div>
            </SegmentedControl.Item>
            <SegmentedControl.Item value="apt">
              <div className="flex">
                <IconRepeat
                  size={18}
                  className={`mr-2 mt-0.5 ${visualizationToShow === 'apt' ? 'text-menuPurple' : 'text-gray-600'}`}
                />
                APT
              </div>
            </SegmentedControl.Item>
            {session?.portalPreferences?.threatIntelEvaluation == false && (
              <SegmentedControl.Item value="raw">
                <div className="flex">
                  <IconDatabase
                    size={18}
                    className={`mr-2 mt-0.5 ${visualizationToShow === 'raw' ? 'text-menuPurple' : 'text-gray-600'}`}
                  />
                  Raw Data
                </div>
              </SegmentedControl.Item>
            )}
          </SegmentedControl.Root>
        )}
      </div>
    </div>
  )
}

export default VisualizationsHeader
